import React from "react";
import { CenteredPhotoWrapper } from "./CenteredPhotoElements";

const CenteredPhoto = () => {
  return <CenteredPhotoWrapper></CenteredPhotoWrapper>;
};

export default CenteredPhoto;
